export const STATUS_PROGRESS = {
	COMPLETED: 'completed',
	CURRENT_STATUS: 'current_status',
	SKIPPED: 'skipped',
	FUTURE: 'future',
}

export const STATUS_PUNCTUALITY = {
	ON_TIME: 'On Time',
	SLIGHT_DELAY: 'Slight Delay',
	DELAY: 'Delay',
}
